import { getClientId } from '@ixigo/pwa';

// Define triggerEvent function on window if it doesn't exist
if (typeof window !== 'undefined') {
	window.triggerEvent = (el: Window, eventName: string, data: string) => {
		let event: CustomEvent;

		if (typeof CustomEvent === 'function') {
			event = new CustomEvent(eventName, { detail: data });
		} else {
			event = document.createEvent('CustomEvent');
			event.initCustomEvent(eventName, true, true, data);
		}
		el.dispatchEvent(event);
	};
}

interface NativePaymentParams {
	/**
	 * any random string. required by native apps but not used internally
	 */
	paymentId: string;

	paymentTransactionId: string;

	/**
	 * product booking id
	 */
	tripId: string;

	/**
	 * flow type - 'PAYMENT_SDK'
	 * hardcoded for now
	 */
	flowType: string;

	/**
	 * product type - 'CAB'
	 */
	productType: string;
}

export interface SdkEvent extends Event {
	detail: string;
	type: string;
}

interface IPaymentResponse {
	message: string;
	status: 'error' | 'canceled' | 'success';
	nextUrl: string | undefined;
}

export interface PaymentDetails {
	paymentTransactionId: string;
	paymentUrl: string;
	gateway: string;
	amount: number;
	expiryTimeMinutes: number;
	fullBurn?: boolean;
}

interface RedirectToPaymentParams {
	bookingId: string;
	paymentDetails: PaymentDetails;
}

export function redirectToPayment(props: RedirectToPaymentParams) {
	const { bookingId, paymentDetails } = props;
	const { paymentTransactionId, paymentUrl } = paymentDetails;
	const data: NativePaymentParams = {
		paymentId: 'DUMMY_PAYMENT_ID',
		paymentTransactionId,
		tripId: bookingId,
		flowType: 'PAYMENT_SDK',
		productType: 'CAB',
	};

	if (
		typeof window?.IxiWebView?.executeNativePayment === 'function' &&
		window.IxiWebView.executeNativePayment(
			JSON.stringify({ product: 'cab', data }),
		)
	) {
		return;
	} else if (window?.webkit?.messageHandlers?.payment) {
		// iOS PSDK
		const psdkPaymentFailed = (event: SdkEvent) => {
			const result: IPaymentResponse = getParsedJSON(
				event.detail,
				'Payment Failed Event',
			);

			if (result?.nextUrl) {
				window.location.href = result.nextUrl;
			}
		};

		const psdkPaymentSuccess = (event: SdkEvent) => {
			const result: IPaymentResponse = getParsedJSON(
				event.detail,
				'Payment Success Event',
			);

			if (result?.nextUrl) {
				window.location.href = result.nextUrl;
			}
		};
		// @ts-ignore
		window.addEventListener('PSDK_PAYMENT_SUCCESS', psdkPaymentSuccess);
		// @ts-ignore
		window.addEventListener('PSDK_PAYMENT_FAILED', psdkPaymentFailed);

		return window.webkit.messageHandlers.payment.postMessage({
			action: 'processNativePayment',
			params: {
				data: JSON.stringify({
					product: 'cabs',
					data: data,
				}),
				success:
					"window.triggerEvent(window, 'PSDK_PAYMENT_SUCCESS', 'TO_REPLACE_PAYLOAD');",
				error:
					"window.triggerEvent(window, 'PSDK_PAYMENT_FAILED', 'TO_REPLACE_PAYLOAD');",
			},
		});
	} else {
		const transformedUrl = new URL(paymentUrl);
		if (
			paymentUrl.includes('/payments/view/home/') &&
			getClientId() !== 'ixiweb'
		) {
			transformedUrl.pathname = '/pay';
			transformedUrl.searchParams.set('transactionId', paymentTransactionId);
		}
		window.location.href = transformedUrl.href;
	}
}

export const getParsedJSON = (toParse: string, parseVariableName: string) => {
	try {
		const parsedJson = JSON.parse(toParse);
		return parsedJson;
	} catch {
		// eslint-disable-next-line no-console
		console.error('parsing error in: ', parseVariableName);
		return {};
	}
};
